export default "__VITE_ASSET__BBd351If__"